import React from "react";
import { observer } from "mobx-react";
import { errorExplanationOptions, getCommentIconRenderingInfo, getInputRenderingInfo, triggerAnalystCommentModal } from '../helpers'
import store from './Stores/SurveyStore'
import { saveValueNew, openPrevYearPanel } from "../control";
import {
    Tooltip,
} from 'react-tippy';
import { checkSpecialSaveConfigs } from "../ibsHelper";
import { getSurveyResponseValue, setSurveyResponseValue } from "../Helpers/General/SurveyResponsesHelper";




const SurveyTextArea = observer((props) => {
    const onChange = e => {
        setSurveyResponseValue(props.name, e.target.value, props);
    };
    const getValue = () => {
        
        if (store.questionMode) {
            return props.name
        } else if (props.dataRow) {
            return (props.dataRow[props.name]);
        }
        return (getSurveyResponseValue(props.name, props))
    }

    var focusValue;
    const onFocus = e => {
        openPrevYearPanel(props.name);
        focusValue = e.target.value;

    }
  
    const onBlur = e => {
        //special configs for saving specifically on tables 
        let specialConfigs = { rowId: null, tableName: null }
        specialConfigs = checkSpecialSaveConfigs(props.participantType)

        var v = getValue();
        //save should go thru the array first saveResponseValue in helpers not the direct target value... 
        if (v != focusValue) {
            saveValueNew(props.name, e.target.value, { tableName: specialConfigs.tableName, rowId: specialConfigs.rowId }); //only save if  not in question mode
        }
        store.previousYearValue = ""

    };

    var commentRenderingInfo = getCommentIconRenderingInfo(props.name)
    var inputRenderingInfo = getInputRenderingInfo(props.name, props.inputType)

    let textAreaClassNames = inputRenderingInfo.textClassName + inputRenderingInfo.inputColor;
    if (props.textAreaClass) textAreaClassNames += ` ${props.textAreaClass}`;
    if (props.doubleSubQuestion) {
        if (props.labelText) textAreaClassNames += " doubleSubTextAreaInput";
        else textAreaClassNames += " subTextAreaInput";
    }
    else if(props.subQuestion) {
        if (props.labelText) textAreaClassNames += " subTextAreaInput";
        else textAreaClassNames += " textAreaInput";
    }
    else {
        textAreaClassNames += " textAreaInput";
    }
    
    return (
        <React.Fragment >
            {inputRenderingInfo && inputRenderingInfo.feedbackComment &&
                <div style={{ marginBottom: '20px' }}>

                <Tooltip
                    disabled={store.questionMode}
                    position="top"
                    trigger="mouseenter"
                    arrow="true"
                    delay={250}
                    size="small"
                    interactive="true"
                    hideOnClick="false"
                    animation="fade"
                    html={(
                        <div className="genericTooltip">
                            <span dangerouslySetInnerHTML={{ __html: inputRenderingInfo.feedbackComment }}></span>
                            <br />
                            {errorExplanationOptions(props.name, inputRenderingInfo, getValue())}


                        </div>
                    )}
                >
                    <textarea onFocus={onFocus} autoComplete="off" onBlur={onBlur} onChange={onChange} className={inputRenderingInfo.textClassName + inputRenderingInfo.inputColor + " textAreaInput"} type="text" name={props.name} placeholder={props.placeholder} value={getValue()}></textarea>
                    
               
                </Tooltip>
                <a title={commentRenderingInfo.hoverComment}><i className={"fa fa-comment" + commentRenderingInfo.className} onClick={() => triggerAnalystCommentModal(props.name)} style={{ visibility: store.analystMode || (store.accountInfo && store.accountInfo.isAnalyst && commentRenderingInfo.className) ? "" : "hidden" }}></i></a>
                &nbsp;</div>
            }
            {!inputRenderingInfo.feedbackComment &&
                <div style={{ marginBottom: '20px' }}>
                <textarea onFocus={onFocus} autoComplete="off" onBlur={onBlur} onChange={onChange} className={textAreaClassNames} name={props.name} placeholder={props.placeholder} value={getValue()}></textarea>
                <a title={commentRenderingInfo.hoverComment}><i className={"fa fa-comment" + commentRenderingInfo.className} onClick={() => triggerAnalystCommentModal(props.name)} style={{ visibility: store.analystMode || (store.accountInfo && store.accountInfo.isAnalyst && commentRenderingInfo.className) ? "" : "hidden" }}></i></a>
                &nbsp;
            </div>
            }

        </React.Fragment>
    );
});
export default SurveyTextArea;


